import { Routes, RouterModule } from '@angular/router';
import { AppMainComponent } from '@biorec/common';
import { AppContainerComponent } from './app-container/app-container.component';
import { AuthGuard } from './auth/auth.guard';

export const routes: Routes = [
	{
		path: '', canActivate: [AuthGuard], component: AppMainComponent, children: [
			{
				path: '', component: AppContainerComponent, children: [
					{ path: '', redirectTo: "/dashboard", pathMatch: "full" },
					{ path: 'dashboard', loadChildren: () => import("../dashboard").then(m => m.DashboardRoutes) },
					{ path: 'personalInfo', loadChildren: () => import("../doctors").then(m => m.DoctorsRoutes) },
					// { path: 'exams', loadChildren: () => import("../exams").then(m => m.ExamsRoutes) }
					{ path: 'referrals', loadChildren: () => import("../referrals").then(m => m.ReferralsRoutes) },
					{ path: 'referralsRequests', loadChildren: () => import("../referrals/requests").then(m => m.RequestsRoutes) },
					{ path: 'my-patients', loadChildren: () => import("../patients").then(m => m.PatientsRoutes) },
					{ path: 'my-inventory', loadChildren: () => import("../inventory").then(m => m.InventoryRoutes) },
					{ path: 'instructions', loadChildren: () => import("../instructions").then(m => m.InstructionsRoutes) },
					{ path: 'invoices', loadChildren: () => import("../invoices").then(m => m.InvoicesRoutes) },
					{ path: 'messages', loadChildren: () => import("../messages").then(m => m.MessagesRoutes) }
				]
			},
		],
	},

	{ path: '**', redirectTo: '/notfound' }
];

export const AppRoutes = RouterModule.forRoot(routes, {
	scrollPositionRestoration: 'enabled',
	anchorScrolling: 'enabled',
	onSameUrlNavigation: 'reload',
	paramsInheritanceStrategy: 'always',
	useHash: false
});
